module.exports = __webpack_public_path__ + "static/media/1.a11c2910.jpg";